<template>
    <svg
        id="Icon_ionic-ios-chatboxes"
        data-name="Icon ionic-ios-chatboxes"
        height="20.208"
        viewBox="0 0 20.205 20.208"
        width="20.205"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            id="Path_2192"
            d="M24.3,11.981H13.537a1.854,1.854,0,0,0-1.851,1.851v7.5a1.849,1.849,0,0,0,1.851,1.846H19.7a.531.531,0,0,1,.369.155l3.061,2.823c.17.165.452.1.452-.141V23.553c0-.291.185-.384.476-.384H24.1a2.022,2.022,0,0,0,2.045-1.846V13.832A1.843,1.843,0,0,0,24.3,11.981Z"
            data-name="Path 2192"
            fill="#afafaf"
            transform="translate(-5.944 -6.035)"
        />
        <path
            id="Path_2193"
            d="M9.516,8.131h8.618V4.959A1.584,1.584,0,0,0,16.55,3.375H4.959A1.584,1.584,0,0,0,3.375,4.959v8.026a1.584,1.584,0,0,0,1.584,1.584H7.927V9.715A1.591,1.591,0,0,1,9.516,8.131Z"
            data-name="Path 2193"
            fill="#afafaf"
            transform="translate(-3.375 -3.375)"
        />
    </svg>
</template>

<script>
export default {
    name: "ColorMeaning",
};
</script>
